export default __webpack_public_path__ + "static/media/image2.7baaaf9d.png";